import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { type DocumentCreationModalViewModel } from './DocumentCreationModalViewModel'
import { DocumentCreationModal } from '@/features/documents/DocumentCreationModal'
import { DocumentCreationItemContainer } from '@/features/documents/DocumentCreationModal/DocumentCreationItem/DocumentCreationItemContainer'

export interface DocumentCreationModalContainerProps {
  vm: DocumentCreationModalViewModel
  /**
   * Shown over the modal while files are dragged onto it.
   */
  overlay: ReactNode
}

export const DocumentCreationModalContainer = observer(
  function DocumentCreationModalContainer({
    vm,
    overlay,
  }: DocumentCreationModalContainerProps) {
    return (
      <DocumentCreationModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        dragging={vm.dragging}
        onAddFiles={vm.addFiles}
        onDragEnter={vm.setDragging}
        onDragLeave={vm.stopDragging}
        uploadDisabled={!vm.canUpload}
        isUploadPending={vm.upload.pending}
        onUpload={vm.upload}
        overlay={overlay}
      >
        {vm.documentCreationItemVms.map((docCreationItemVm, index) => (
          <div key={docCreationItemVm.id}>
            <DocumentCreationItemContainer
              index={index}
              vm={docCreationItemVm}
              onRemove={vm.removeFile}
            />
          </div>
        ))}
      </DocumentCreationModal>
    )
  },
)
